/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';
export const interventiAPI = {
  list: async (params = {}) => { const { data } = await apiClient.get('/interventi', { params }); return data; },
  detail: async (id) => { const { data } = await apiClient.get(`/interventi/${id}`); return data; },
  changeStato: async (id, stato) => { const { data } = await apiClient.patch(`/interventi/${id}/stato`, { stato }); return data; },
  completa: async (id, note_finali, dichiarazione_accettata) => { const { data } = await apiClient.post(`/interventi/${id}/completa`, { note_finali, dichiarazione_accettata }); return data; },
  // Materiali
  addMateriale: async (id, body) => { const { data } = await apiClient.post(`/interventi/${id}/materiali`, body); return data; },
  removeMateriale: async (id, rigaId) => { const { data } = await apiClient.delete(`/interventi/${id}/materiali/${rigaId}`); return data; },
  // Strumenti
  listStrumenti: async (id) => { const { data } = await apiClient.get(`/interventi/${id}/strumenti`); return data; },
  addStrumento: async (id, body) => { const { data } = await apiClient.post(`/interventi/${id}/strumenti`, body); return data; },
  removeStrumento: async (id, rigaId) => { const { data } = await apiClient.delete(`/interventi/${id}/strumenti/${rigaId}`); return data; },
};
